<div class="l_flexbar m-l_flexbar-col">
  <dgx-data-search
    [placeholder]="searchPlaceholderText"
    [searchTerm]="searchTerm"
    (doSearch)="updateQuery($event)"
    type="short"
    class="m-full-width l_flex-grow guts-m-r-1 m-guts-m-b-half m-guts-m-r-0"
  ></dgx-data-search>

  @if (!isSkillsClient) {
    <div class="m-guts-p-t-1 l_flexbar gap-full-1 m-l_flexbar-col">
      @if (canInviteMembers) {
        <button
          type="button"
          class="tw-btn-primary tw-btn-medium"
          (click)="inviteMembers($event)"
          data-dgat="orgMembers-6ec"
        >
          <da-icon
            icon="plus"
            type="solid-small"
            class="tw-reset tw-inline-block tw-align-middle"
          ></da-icon>
          {{ inviteButtonText }}
        </button>
      }
      @if (canUpdateUsers) {
        <dgx-ftp-upload-link
          buttonText="{{ 'OrgManage_UpdateUsers' | translate }}"
          [fileUploadType]="userUpdateType"
          icon="arrow-path"
          [orgId]="orgId"
        ></dgx-ftp-upload-link>
      }
      @if (canUploadUsers) {
        <dgx-ftp-upload-link
          buttonText="{{ 'OrgManage_UploadUsers' | translate }}"
          [fileUploadType]="userUploadType"
          icon="arrow-up-tray"
          [orgId]="orgId"
        ></dgx-ftp-upload-link>
      }
    </div>
  }
</div>
